import { default as _91_46_46_46slug_93MISCMoQcHbMeta } from "/home/forge/shop.ullmax.com/releases/20250811090653/pages/[...slug].vue?macro=true";
import { default as createCartBrOyPDgrhCMeta } from "/home/forge/shop.ullmax.com/releases/20250811090653/pages/[[lang]]/createCart.vue?macro=true";
import { default as payment_45returnw5kfdM071xMeta } from "/home/forge/shop.ullmax.com/releases/20250811090653/pages/[[lang]]/payment-return.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93MISCMoQcHbMeta?.name ?? "slug",
    path: _91_46_46_46slug_93MISCMoQcHbMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93MISCMoQcHbMeta || {},
    alias: _91_46_46_46slug_93MISCMoQcHbMeta?.alias || [],
    redirect: _91_46_46_46slug_93MISCMoQcHbMeta?.redirect,
    component: () => import("/home/forge/shop.ullmax.com/releases/20250811090653/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: createCartBrOyPDgrhCMeta?.name ?? "lang-createCart",
    path: createCartBrOyPDgrhCMeta?.path ?? "/:lang?/createCart",
    meta: createCartBrOyPDgrhCMeta || {},
    alias: createCartBrOyPDgrhCMeta?.alias || [],
    redirect: createCartBrOyPDgrhCMeta?.redirect,
    component: () => import("/home/forge/shop.ullmax.com/releases/20250811090653/pages/[[lang]]/createCart.vue").then(m => m.default || m)
  },
  {
    name: payment_45returnw5kfdM071xMeta?.name ?? "lang-payment-return",
    path: payment_45returnw5kfdM071xMeta?.path ?? "/:lang?/payment-return",
    meta: payment_45returnw5kfdM071xMeta || {},
    alias: payment_45returnw5kfdM071xMeta?.alias || [],
    redirect: payment_45returnw5kfdM071xMeta?.redirect,
    component: () => import("/home/forge/shop.ullmax.com/releases/20250811090653/pages/[[lang]]/payment-return.vue").then(m => m.default || m)
  }
]